
const loadCaptchaBasic = () => import('captcha_basic').then(module => module.default);
export const basic_captcha = loadCaptchaBasic
const loadQuickLinks = () => import('quick-links').then(module => module.default);
export const quick_links = loadQuickLinks